import React, { FC, useEffect, Dispatch, useReducer } from 'react'
import { Address, ChainConfiguration } from '../../utils/types'
import { Swap } from '../../logic/swaps/Swap'
import { SimpleLoader } from '../catalog/SwaapLoader'
import { SmallCheckCircle } from '../catalog/icons/CheckCircle'
import { IDeposit } from '../../logic/deposits/Deposit'
import { IWithdrawal } from '../../logic/withdrawals/Withdrawals'

type Nonce = string
export type Hash = string
export type Timestamp = number
import {
  INITIAL_TRANSACTION_STATE,
  SubmittedTransaction,
  Transaction,
  TransactionAction,
  transactionsReducer,
  TransactionsState,
} from '../../logic/transactions/transactions'

const initialState: TransactionsState = INITIAL_TRANSACTION_STATE()

interface TransactionContext {
  transactions: TransactionsState
  dispatcher: Dispatch<TransactionAction>
}

const TransactionContext = React.createContext<TransactionContext>({
  transactions: INITIAL_TRANSACTION_STATE(),
  // @ts-ignore
  dispatcher: undefined,
})

export const TransactionProvider: FC = ({ children }) => {
  const [transactions, transactionDispatcher] = useReducer(
    transactionsReducer,
    initialState
  )

  return (
    <TransactionContext.Provider
      value={{ transactions, dispatcher: transactionDispatcher }}
    >
      {children}
    </TransactionContext.Provider>
  )
}

export const useTransactions = () => React.useContext(TransactionContext)

export function useTransaction(
  transactionHash: string
): Transaction | undefined {
  const { transactions } = useTransactions()

  return transactions.all.find(
    t => t.submitted && t.submitted.hash === transactionHash
  )
}
